import React from "react";
import styles from "./PlaydateInviteRecipientView.module.css";
import {
    PlaydateInviteResponse,
    ResponseType,
} from "../../../gql/types";
import { convertScheduleOptionsToDayPartSelections } from "../../../service/playdate/converters/converter";
import ActionButton from "../../button/ActionButton";
import UnderlineButton from "../../button/UnderlineButton";
import PlaydateInviteBaseView from "./PlaydateInviteBaseView";
import PlaydateInviteGuestResponse from "../PlaydateInviteGuestResponse";

export type PlaydateInviteCurrentResponseViewProps = {
    response: PlaydateInviteResponse;
    onBack: () => void;
    onModify: () => void;
    onReject: () => void;
    baseZIndex?: number;
};

const PlaydateInviteCurrentResponseView: React.FC<PlaydateInviteCurrentResponseViewProps> = ({
    response,
    onBack,
    onModify,
    onReject,
    baseZIndex,
}) => {
    return (
        <PlaydateInviteBaseView
            baseZIndex={baseZIndex}
            onBack={onBack}
            title="Response Details"
            infoText={"You've responded to this invite previously — update if needed."}
            topIcon="happy"
        >
            <PlaydateInviteGuestResponse
                responseStatus={response.responseType}
                selectedDates={
                    response.selectedScheduleOptions ?
                        convertScheduleOptionsToDayPartSelections(response.selectedScheduleOptions)
                        : undefined}
                messageToHost={response.message !== null ? response.message : ""}
            />
            <div className={styles.buttonContainer}>
                <ActionButton
                    onClick={onModify}
                >
                    Update My RSVP
                </ActionButton>
                {(response.responseType !== ResponseType.Reject) && <ActionButton
                    onClick={onReject}
                >
                    We can no longer make it
                </ActionButton>}
                <UnderlineButton onClick={onBack}>
                    Back to Invite Details
                </UnderlineButton>
            </div>
        </PlaydateInviteBaseView>
    );
};

export default PlaydateInviteCurrentResponseView;
